/**
 * Common color chart for the application.
 * Used for badges, icons, messages, and theme configuration.
 *
 * Updated to align with design system functional colors.
 */
export const colors = {
  // Functional colors (design system)
  success: '#10B981', // Emerald - active statuses
  error: '#DC3444', // Legacy, prefer destructive: '#EF4444'
  destructive: '#EF4444', // Red - irreversible actions
  warning: '#F59E0B', // Amber - non-destructive alerts
  info: '#10CAF0', // Legacy cyan

  // Status badge colors (design system)
  statusActive: {
    background: '#D1FAE5',
    color: '#065F46',
  },
  statusSuspended: {
    background: '#FEF3C7',
    color: '#92400E',
  },
  statusRevoked: {
    background: '#FEE2E2',
    color: '#991B1B',
  },

  // Neutral scale (slate)
  disabled: '#6C757D',

  // Legacy greys (for backwards compatibility)
  grey: {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#6C757D',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  },
} as const;

export type AppColor = keyof typeof colors;
